import { ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateReferrer } from '../../reducers/graph';

interface ReferrerProps {
  referrer?: string;
  children: ReactNode;
}

export const Referrer = ({ referrer, children }: ReferrerProps) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (referrer) {
      dispatch(updateReferrer(referrer));
    }
  }, [dispatch, referrer]);

  return children;
};
